import { css } from 'styled-components';
import { STATIC_BASE_URL, pxToRem } from '@anwb/style-utilities';
import { ANWBDefault } from '@anwb/theme';
import { ButtonIconChild, ButtonText } from './button.styled';
/**
 * Button primary
 */
export const primaryVariantStyles = ({ theme }) => css `
	background: ${theme.colors.gradients.buttonPrimary};

	${ButtonText}, ${ButtonIconChild} {
		color: ${theme.colors.blanc.textButton};
	}

	&:focus,
	&:hover {
		background: ${theme.colors.gradients.buttonPrimaryHover};
	}

	&:active {
		background: ${theme.colors.gradients.buttonPrimaryActive};
	}
`;
/**
 * Button secondary
 */
export const secondaryVariantStyles = ({ theme }) => css `
	padding-top: ${pxToRem(Number(theme.spacing['200']) - Number(theme.borderWidth['2']))};
	padding-bottom: ${pxToRem(Number(theme.spacing['200']) - Number(theme.borderWidth['2']))};
	border: ${pxToRem(theme.borderWidth['2'])} solid ${theme.colors.base.borderButton};

	${ButtonText}, ${ButtonIconChild} {
		color: ${theme.colors.base.textBody};
	}

	&:focus,
	&:hover {
		border: ${pxToRem(theme.borderWidth['2'])} solid ${theme.colors.highlight.borderHover};

		${ButtonText}, ${ButtonIconChild} {
			color: ${theme.colors.highlight.textHover};
		}
	}

	&:active {
		border: ${pxToRem(theme.borderWidth['2'])} solid
			${theme.colors.action.borderButtonInverseActive};

		${ButtonText}, ${ButtonIconChild} {
			color: ${theme.colors.action.textButtonInverseActive};
		}
	}
`;
/**
 * Button tertiary
 */
export const tertiaryVariantStyles = ({ theme, $visualStyle, }) => css `
	&& {
		padding-top: ${pxToRem(Number(theme.spacing['100']) - 1)};
		padding-bottom: ${pxToRem(Number(theme.spacing['100']) - 1)};

		${$visualStyle === 'secondary' &&
    css `
			padding: ${pxToRem(Number(theme.spacing['100']) - (1 + Number(theme.borderWidth['2'])))}
				${pxToRem(Number(theme.spacing['350']) - Number(theme.borderWidth['2']))};
		`}
	}
`;
/**
 * Button decide
 */
export const decideVariantStyles = ({ theme }) => css `
	background: ${theme.colors.gradients.buttonPrimaryDecide};
	color: ${theme.colors.base.textButton};

	${ButtonText}, ${ButtonIconChild} {
		color: ${theme.colors.base.textButton};
	}

	&:focus,
	&:hover {
		background: ${theme.colors.gradients.bgButtonPrimaryDecideHover};

		${ButtonText}, ${ButtonIconChild} {
			color: ${theme.colors.base.textButton};
		}
	}

	&:active {
		background: ${theme.colors.gradients.bgButtonPrimaryDecideActive};

		${ButtonText}, ${ButtonIconChild} {
			color: ${theme.colors.base.textButton};
		}
	}

	${ANWBDefault.name === theme.name &&
    css `
		color: ${theme.colors.blanc.textButton};

		${ButtonText}, ${ButtonIconChild} {
			color: ${theme.colors.blanc.textButton};
		}

		&:focus,
		&:hover {
			${ButtonText}, ${ButtonIconChild} {
				color: ${theme.colors.blanc.textButton};
			}
		}

		&:active {
			${ButtonText}, ${ButtonIconChild} {
				color: ${theme.colors.blanc.textButton};
			}
		}
	`}
`;
/**
 * Button inverted
 */
export const invertedVariantStyles = ({ theme }) => css `
	background: transparent;
	border: ${pxToRem(theme.borderWidth['2'])} solid ${theme.colors.blanc.borderButtonInverse};

	${ButtonText}, ${ButtonIconChild} {
		color: ${theme.colors.blanc.textButtonInverse};
	}

	&:focus,
	&:hover {
		border: ${pxToRem(theme.borderWidth['2'])} solid ${theme.colors.medium.borderButtonInverseHover};

		${ButtonText}, ${ButtonIconChild} {
			color: ${theme.colors.medium.textButtonInverseHover};
		}
	}

	&:active {
		border: ${pxToRem(theme.borderWidth['2'])} solid
			${theme.colors.action.borderButtonInverseActive};

		${ButtonText}, ${ButtonIconChild} {
			color: ${theme.colors.action.textButtonInverseActive};
		}
	}
`;
/**
 * Button toggle
 */
export const toggleVariantStyles = ({ theme }) => css `
	border: ${pxToRem(theme.borderWidth['2'])} solid ${theme.colors.base.borderTabbox};
	padding: 0;
	overflow: hidden;
	display: inline-block;

	> ${ButtonText} {
		display: flex;
		justify-content: center;
		color: ${theme.colors.base.textButton};

		> span {
			flex: 1;
			padding-top: ${pxToRem(Number(theme.spacing['200']) - Number(theme.borderWidth['2']))};
			padding-bottom: ${pxToRem(Number(theme.spacing['200']) - Number(theme.borderWidth['2']))};

			&.active {
				color: ${theme.colors.blanc.textButton};
				background: ${theme.colors.base.bgTabTabboxActive};

				&:after {
					content: url(${`${STATIC_BASE_URL}/poncho/button/images/toggle-icon.svg`});
					margin-left: ${pxToRem(theme.spacing['200'])};
				}
			}

			&:not(.active) {
				background: ${theme.colors.blanc.bgTabboxContent};
			}
		}
	}
`;
//# sourceMappingURL=button-variants.styled.js.map